module.exports = __webpack_public_path__ + "img/Vertex-Degrees-vs.-Neighbors-Degrees-300x300.43cd59e2.png";